import Page from "lib/components/layout/Page";
import type { ReactNode } from "react";
import cx from "ui/cx";
import { HorizontalSplitGroup, SplitAlignment } from "ui/layouts/Split";
import styles from "./BuilderPortalLayoutFrame.module.scss";

interface BuilderPortalLayoutFrameProps {
  pageTitle: string;
  className?: string;
  topNav?: ReactNode;
  sideNav?: ReactNode;
  children: ReactNode;
}

export default function BuilderPortalLayoutFrame({
  pageTitle,
  className,
  topNav,
  sideNav,
  children,
}: BuilderPortalLayoutFrameProps) {
  const mainContent = (
    <section
      className={cx(styles.contentWrapper, sideNav ? styles.withSideNav : undefined, className)}
      id="scrollContainer"
      data-testid="scrollContainer"
    >
      {children}
    </section>
  );
  return (
    <Page pageTitle={pageTitle} className={styles.verticalWrapper}>
      {topNav}
      <div className={styles.horizontalWrapper}>
        {sideNav ? (
          <HorizontalSplitGroup
            initialFixedSideSize={264}
            flexibleSide={SplitAlignment.LAST}
            minPanelSize={200}
            highlightSeparator
          >
            {sideNav}
            {mainContent}
          </HorizontalSplitGroup>
        ) : (
          mainContent
        )}
      </div>
    </Page>
  );
}
